import { getLocalRecentHistoryList } from './getLocalRecentHistory';

type Props = {
    isClient: boolean;
};
type LocalHistoryItemIdsReturn = [] | string[];

export const getLocalHistoryItemIds = ({ isClient }: Props): LocalHistoryItemIdsReturn => {
    if (!isClient) {
        return [];
    }
    // get local recently viewed items
    const localRecentItems = getLocalRecentHistoryList().reverse();

    return localRecentItems.map(({ itemId }) => itemId);
};
